import React from 'react';

function Alert({ message }) {
  if (!message?.text) return null;
  const text = typeof message.text === 'string'
    ? message.text
    : Array.isArray(message.text)
      ? message.text.map((x) => (typeof x === 'string' ? x : x?.msg || JSON.stringify(x))).join(' ')
      : (message.text?.msg || String(message.text));
  return <div className={`alert alert-${message.type}`}>{text}</div>;
}

export default Alert;
